import correction from './corrections/correction.store';
import performancesActionLog from './performances-action-log/performances-action-log.store';
import timetable from './timetables/timetable.store';

import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { CustomerContractsOverview } from '../contracts-overview/contracts-overview.interface';
import { Employment } from '../employments/employment.interface';
import { Contract } from './contract.interface';
import { employmentMapper } from './contract.mapper';
import { ContractService } from './contract.service';

const service = new ContractService();

export interface ContractState {
   customersContractsOverview: { [key: string]: Array<CustomerContractsOverview> };
}

const ContractStore: Module<ContractState, StoreState> = {
   namespaced: true,
   state: {
      customersContractsOverview: {},
   },
   getters: {},
   mutations: {
      SET_CUSTOMERS_CONTRACTS_OVERVIEW(state, payload: { key: string; value: Array<CustomerContractsOverview> }) {
         state.customersContractsOverview = { ...state.customersContractsOverview, [payload.key]: payload.value };
      },
   },
   actions: {
      async getContractCustomers(context, query: LocationQuery) {
         return await service.getCustomersWithContracts(query);
      },
      async getContracts(context, query: LocationQuery) {
         return await service.getContracts(query);
      },
      async changeEmployment(context, { contractId, employment }: { contractId: number; employment: Employment }) {
         return await service.putContract(contractId, employmentMapper(employment));
      },
      async getContractById(context, { contractId, query }: { contractId: number; query?: LocationQuery }) {
         return await service.getContractById(contractId, query);
      },
      async getContractTranslations(context, importFile: any) {
         return await service.postContractTranslations(importFile);
      },
      async uploadContracts(context, data: { importFile: any; translations: any }) {
         return await service.uploadContracts(data.importFile, data.translations);
      },
      async getLastContractFromCustomerAndEmployeeAndDate(context, payload: { customerId: number; employeeId: number; date: string }) {
         return await service.getLastContractFromCustomerAndEmployeeAndDate(payload.customerId, payload.employeeId, payload.date);
      },
      async postPerformanceChange(context, performanceChange: any) {
         return await service.postPerformanceChange(performanceChange);
      },
      async patchContract(context, payload: { contractId: number; itemsToPatch: Array<any> }) {
         return await service.patchContract(payload.contractId, payload.itemsToPatch);
      },
      async deleteContract(context, contract: any) {
         return await service.deleteContract(contract.id);
      },
      async signContract(context, contractId: number) {
         return await service.signContract(contractId);
      },
      async indexContractCommuterTrafficBatches(context, contractIds: Array<number>) {
         return await service.indexContractCommuterTrafficBatches(contractIds);
      },
      async copyContractDataBatches(context, payload: { contractId: number; employment: Employment }) {
         return await service.copyContractDataBatches(payload.contractId, employmentMapper(payload.employment));
      },
      async print(context, contractId: number) {
         return await service.print(contractId);
      },
      async batchDeleteContracts(context, contracts: Array<Contract>) {
         const batch = await service.batchDeleteContracts(contracts.map((c) => c.id));
         context.commit('batch/ADD_BATCH', batch, { root: true });
         return batch;
      },
      async exportContracts(context, contractIds: Array<number>) {
         const batch = await service.exportContracts(contractIds);
         context.commit('batch/ADD_BATCH', batch, { root: true });
         return batch;
      },
   },
   modules: {
      timetable,
      correction,
      performancesActionLog,
   },
};

export default ContractStore;
